/*
 * @Author: cc
 * @Date: 2019-11-25 12:52:26
 * @LastEditTime: 2021-03-29 16:35:54
 * @LastEditors: cc
 * @FilePath: \xjmediacloud\app\manageConfig\productManageMent\television\service\createChannel\createChannel.js
 * @Description: 
 */
'use strict';
angular.module('createChannelModule', [])
    .controller('createChannelCtrl', ['$scope', 'channelBaseData', '$modalInstance', '$validation', 'trsHttpService', 'modalDialog', '$q', '$stateParams', function($scope, channelBaseData, $modalInstance, $validation, trsHttpService, modalDialog, $q, $stateParams) {
        initStatus();
        initData();

        /**
         * [initStatus description]
         * @return  {[type]}  [return description]
         */
        function initStatus() {
            $scope.status = {
                channelTitle: channelBaseData.isNew ? '新建栏目' : '修改栏目',
                siteid: $stateParams.siteid,
                channelId: channelBaseData.data ? channelBaseData.data.CHANNELID : '',
            };
            $scope.data = {
                channelName: '',
            };
        }

        /**
         * [initData description]
         * @return  {[type]}  [return description]
         */
        function initData() {
            if (!channelBaseData.isNew) {
                queryByChannelId();
            }
        }

        /**
         * [queryByChannelId 查询指定栏目信息]
         * @return {[type]} [description]
         */
        function queryByChannelId() {
            var params = {
                serviceid: 'mlf_tvconfig',
                methodname: 'findChannelById',
                ChannelId: $scope.status.channelId,
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data){
                $scope.data.channelName = data.CHNLDESC;
            });
        }

        /**
         * [submit 新增、修改提交操作]
         * @return {[type]} [description]
         */
        function submit() {
            var defer = $q.defer();
            var params = {
                serviceid: 'mlf_tvconfig',
                methodname: 'saveNewChnl',
                ObjectId: channelBaseData.isNew ? '0' : $scope.status.channelId,
                SiteId: $scope.status.siteid,
                ChnlName: $scope.data.channelName,
                ChnlDesc: $scope.data.channelName,
                ParentId: '0', // 站点下的一级栏目, ParentId默认为0,前端写死
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                modalDialog.alertType('提交成功', '', 'success', false, function() {
                    defer.resolve();
                    $modalInstance.close('success');
                });
            });
            return defer.promise;
        }

        /**
         * [confirm 确定]
         * @return {[type]} [description]
         */
        $scope.confirm = function() {
            $validation.validate($scope.createChannelForm).success(function() {
                submit();
            }).error(function() {
                modalDialog.alertType('提交失败', '请检查表单', 'info', false, function(){});
            });
        };

        /**
         * [close 取消]
         * @return {[type]} [description]
         */
        $scope.close = function() {
            $modalInstance.dismiss();
        };
    }]);
